import { ApiService } from 'react-angle-dashboard-components'

import {
  PlanService,
  GroupService,
  EmployeeService,
  EmailService,
  MemberService
} from './api'
import { AuthService } from './api/auth'

const BASE_URL = (window as any).runtimeConfig?.apiURL

const apiUrl = `${BASE_URL}/selfserve`

export const planService = new PlanService(apiUrl)
export const groupService = new GroupService(apiUrl)
export const employeeService = new EmployeeService(apiUrl)
export const emailService = new EmailService(apiUrl)
export const memberService = new MemberService(apiUrl)
export const authService = new AuthService(apiUrl)

export { ApiService }
